import { Box, Button, Typography, useTheme } from "@mui/material";
import {
  eyebrowSx,
  primaryButtonSx,
  stepSubtitleSx,
  stepTitleSx,
  textPrimary,
} from "./stepStyles";

/**
 * Shared layout for the affirmation and pain interstitials: eyebrow, tailored
 * copy, an unframed chart centered in the remaining space, pinned CTA.
 */

interface InterstitialStepProps {
  eyebrow: string;
  copy: { title: string; body: string };
  chart: React.ReactNode;
  ctaLabel: string;
  onContinue: () => void;
}

export const InterstitialStep = ({
  eyebrow,
  copy,
  chart,
  ctaLabel,
  onContinue,
}: InterstitialStepProps) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Box sx={{ pt: 1, display: "flex", flexDirection: "column", flex: 1 }}>
      <Typography sx={eyebrowSx(isDark)}>{eyebrow}</Typography>
      <Typography sx={{ ...stepTitleSx(isDark), mt: 0.75, color: textPrimary(isDark) }}>
        {copy.title}
      </Typography>
      {/* Blank lines in the copy become real paragraph breaks. */}
      {copy.body.split("\n\n").map((paragraph, index) => (
        <Typography
          key={paragraph}
          sx={{ ...stepSubtitleSx(isDark), mt: index === 0 ? 1.5 : 2, lineHeight: 1.6 }}
        >
          {paragraph}
        </Typography>
      ))}
      {/* Chart centers itself in the space between the copy and the CTA. */}
      <Box sx={{ flex: 1, display: "flex", alignItems: "center", py: 2 }}>{chart}</Box>
      <Button fullWidth onClick={onContinue} sx={{ ...primaryButtonSx, mt: 3 }}>
        {ctaLabel}
      </Button>
    </Box>
  );
};
